import s from "./index2.js";
import { resolveComponent as l, openBlock as i, createElementBlock as c, normalizeClass as n, createVNode as u, withCtx as h, createElementVNode as r, toDisplayString as p } from "vue";
import "./index3.js";
import d from "../../../../_virtual/index.js";
function m(e, o, g, S, f, C) {
  const t = l("SearchInput");
  return i(), c("div", {
    class: n(["search", e.hasSearchIcon ? "full-width" : ""])
  }, [
    u(t, {
      suggestions: e.suggestions,
      inputEnterKeyPressHandler: e.handleSearchSubmitButtonClick,
      placeholder: e.placeholder,
      algoliaExpVar: e.algoliaExpVar,
      config: e.config,
      onUpdateQuery: e.updateQuery
    }, {
      "search-submit": h(() => [
        r("button", {
          class: n(["search-submit", e.hasSearchButton ? "" : "no-search-submit"]),
          onClick: o[0] || (o[0] = (...a) => e.handleSearchGoButtonClick && e.handleSearchGoButtonClick(...a))
        }, p(e.t("header.go")), 3),
        r("button", {
          class: n(["search-icon", e.hasSearchIcon ? "" : "no-search-icon"]),
          onClick: o[1] || (o[1] = (...a) => e.handleSearchGoButtonClick && e.handleSearchGoButtonClick(...a))
        }, null, 2)
      ]),
      _: 1
    }, 8, ["suggestions", "inputEnterKeyPressHandler", "placeholder", "algoliaExpVar", "config", "onUpdateQuery"])
  ], 2);
}
const y = /* @__PURE__ */ d(s, [["render", m], ["__scopeId", "data-v-e98edeee"]]);
export {
  y as default
};
//# sourceMappingURL=index.js.map
